import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import FooterButton from '@/checkout-instore-legacy/components/Commons/Elements/FooterButton'

export default function NewOrder({ onClick }) {
  return (
    <FooterButton id="new-order" kind="primary" onClick={onClick}>
      <FormattedMessage id="orderPlacedStartNewSale" />
    </FooterButton>
  )
}

NewOrder.propTypes = {
  onClick: PropTypes.func.isRequired,
}
